import {put, takeEvery, call} from 'redux-saga/effects';
import {
    SEARCH_USER_ACTION_FETCH,
    SEARCH_USER_ACTION_REQUEST,
    SEARCH_USER_ACTION_SUCCESS,
    SEARCH_USER_ACTION_FAILURE,
    SEARCH_USER_CLEAR_ACTION
} from './constants';
import Api, {ApiMethods} from 'feedback-system/middleware/api';

function* searchUserData(action: any) {
    try {
        yield put({type: SEARCH_USER_ACTION_REQUEST});
        yield new Promise(resolve => setTimeout(resolve, 500));
        const data = yield call(Api.fetch, {
            endpoint: `profiles/search?q=${action.q}`,
            method: ApiMethods.GET
        });
        yield put({type: SEARCH_USER_ACTION_SUCCESS, data: data.responseData});
    } catch (e) {
        yield put({type: SEARCH_USER_ACTION_FAILURE, error: e});
    }
}

function* searchAddUserSaga() {
    yield takeEvery(SEARCH_USER_ACTION_FETCH, searchUserData);
}

function* searchAddUserClrSaga() {
    yield put({type: SEARCH_USER_CLEAR_ACTION});
}

export {
    searchAddUserSaga,
    searchAddUserClrSaga
};
